import { saucelabsDomainRoot } from '@saucelabs/sl-util-axios';

export const getDownloadLinks = () => (
  saucelabsDomainRoot.get('/versions.json')
);
